// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"a7f0ef78","442":"a7f0ef78","609":"a7f0ef78"}[chunkId] + ".chunk.css";
};